import { addRest, getValue, nonZero } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function heatingModes2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        obj.name,
        obj.heating_zones.map((x) => x.heating_circuit),
        obj.heating_zones.map((x) => x.temperature_setting),
        obj.heating_zones.map((x) => x.adjusting_sensor != null ? x.adjusting_sensor : 0),
        Number(obj.setting_register),
        obj.heating_zones.map((x) => (x.pza != null ? x.pza : 0)),
        Number(obj.start_reserve_delay || 10),
        (obj.water_sensor || null) != null ? Number(obj.water_sensor) : 0,
        Math.round((obj.hysteresis || 0) * 10),
        obj.position || 0,
        obj.max_modulation_level || 0,
        ...(obj.rest || []),
    ]);
}
function heatingModesFromStr(id, params) {
    let pzas = getValue(params, 5, []);
    if (pzas.length === 0) {
        pzas = params[1].map((_) => 0);
    }
    const heatingZones = pzas
        .map((_, i) => ({
        heating_circuit: params[1][i],
        temperature_setting: params[2][i],
        adjusting_sensor: params[3][i],
        pza: pzas[i],
    }))
        .map((v) => ({
        heating_circuit: v.heating_circuit,
        temperature_setting: v.temperature_setting,
        adjusting_sensor: v.adjusting_sensor === 0 ? null : v.adjusting_sensor,
        pza: v.pza !== 0 ? v.pza : null,
    }));
    return {
        id: id,
        name: params[0],
        heating_zones: heatingZones,
        setting_register: params[4],
        start_reserve_delay: getValue(params, 6, 10),
        water_sensor: nonZero(params, 7),
        hysteresis: getValue(params, 8, 0) / 10,
        position: getValue(params, 9, 0),
        force_boiler_mode: false,
        max_modulation_level: getValue(params, 10, 0),
        ...addRest(params, 11),
    };
}
export const heating_modes_parser = {
    toStr: heatingModes2Str,
    fromStr: heatingModesFromStr,
};
